import axios from 'axios'
import momentFormat from '../mixins/momentFormat'
import { apiEnv, startDate, endDate } from "../env.js";
var apiPath = apiEnv();
export default {
  mixins: [momentFormat],
  data () {
    return {
      loaded: false,
      today: '',
      scheduleDownload: '',
      scheduleEvent: '',
      scheduleIcon: '',
      currentday: startDate + ' 00:00:00',
      page: 0,
      dates: [],
      acts: []
    }
  },
  beforeCreate () {
    axios
      .get(apiPath + '/venues/acts')
      .then((res) => {
        for (let i = 0, d = res.data.length; i < d; ++i) {
          let area = res.data[i]
          for (let ci = 0, a = area.children.length; ci < a; ++ci) {
            let cinema = area.children[ci]
            cinema.venue_number = 1
            for (let ai = 0, c = cinema.acts.length; ai < c; ++ai) {
              let act = cinema.acts[ai]
              if(act.venue.order > cinema.venue_number) cinema.venue_number = act.venue.order
              if(act && act.column > 0) {
                cinema[act.act_date] = true
                area[act.act_date] = true
              }
            }
          }
        }
        this.acts = res.data
        console.log(this.acts[0])
        this.loaded = true
      }).catch((error) => {
        this.loaded = true
      })
  },
  created() {
    for (var i = 0; i <= this.daysDiff(startDate, endDate);i++){
      this.dates.push(this.addDays(startDate,i))
    }
  },
	watch: {
		'$route' (to, from) {
			this.changeParam(to.params.id)
		}
	},
  methods: {
    changeParam (val) {
      this.page = this.dates.indexOf(val);
      console.log(this.page)
      this.currentday = val + ' 00:00:00'
    },
		prevParam () {
			this.page --
      this.changeRoute()
		},
		nextParam () {
			this.page ++
      this.changeRoute()
		},
  }
}



// WEBPACK FOOTER //
// ./src/mixins/schedule.js